module.exports = __webpack_public_path__ + "assets/img/erweima-gzh.2f4f8f15.jpg";